import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

// 🔹 Define Zod Schema for EmailTemplateForm
const EmailTemplateSchema = z.object({
  id: z.string().nullable(),
  name: z.string(),
  content: z.string(),
});

// 🔹 Define Zod Schema for EmailTemplateForm
const LetterTemplateSchema = z.object({
  id: z.string().nullable(),
  category_id: z.string(),
  name: z.string(),
  subject: z.string(),
  sub_header: z.string(),
  content: z.string(),
});

// 🔹 Define Zod Schema for GlobalLetterForm
const GlobalLetterSchema = z.object({
  firm_contact: z.union([z.string(), z.number()]),
  pm_priority: z.string(),
  opening: z.string(),
  closing: z.string(),
  header_font: z.string(),
  header_font_size: z.string(),
  font: z.string(),
  font_size: z.string(),
  top_margin: z.string(),
  follower_top_margin: z.string(),
  bottom_margin: z.string(),
  follower_bottom_margin: z.string(),
  salutation_margin: z.string(),
  max_width: z.string(),
  max_height: z.string(),
  signature: z.string(),
  merge_template: z.string(),
  tagline: z.string(),
  page_num: z.boolean(),
  'signature-preview': z.object({
    sign_name: z.string(),
    sign_qualifications: z.string(),
    sign_role: z.string(),
    firm_name: z.string(),
  }),
  'signature-image': z.string(),
  email_template: EmailTemplateSchema,
  letter_template: LetterTemplateSchema,
});

export type GlobalLetterForm = z.infer<typeof GlobalLetterSchema>;

// 🔹 Define default values
export const GlobalLetterDefaultValues: GlobalLetterForm = {
  firm_contact: 0,
  pm_priority: 'Partner',
  opening: 'Default',
  closing: 'Default',
  header_font: 'Arial',
  header_font_size: '10',
  font: 'Arial',
  font_size: '8',
  top_margin: '1',
  follower_top_margin: '1',
  bottom_margin: '1',
  follower_bottom_margin: '1',
  salutation_margin: '1',
  max_width: '1',
  max_height: '10',
  signature: '',
  merge_template: '',
  tagline: '',
  page_num: false, // Defaulting boolean to false
  'signature-preview': {
    sign_name: '',
    sign_qualifications: '',
    sign_role: '',
    firm_name: '',
  },
  'signature-image': '',
  email_template: {
    id: null,
    name: '',
    content: '',
  },
  letter_template: {
    id: null,
    category_id: '',
    name: '',
    subject: '',
    sub_header: '',
    content: '',
  },
};

export const useGlobalLetterForm = () => {
  const form = useForm({
    defaultValues: GlobalLetterDefaultValues,
    resolver: zodResolver(GlobalLetterSchema),
    reValidateMode: 'onBlur',
    disabled: false,
  });

  return form;
};
